import React, { useCallback } from 'react';
import Select from '../../reusable/Select/Select';
import LabelField from '../LabelField';

const WeekStartSelect = ({ value, options, onChange }) => {
  const handleChange = useCallback((selected, meta) => {
    onChange(selected, meta);
  }, [onChange]);

  return (
    <>
      <LabelField>Select Starting Day</LabelField>
      <Select
        name="week_start_day"
        value={value || ''}
        options={options}
        onChange={handleChange}
      />
    </>
  );
};

export default WeekStartSelect;